import { Button, Center, Group, Pagination, Stack } from "@mantine/core";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { useQueryVenues, useDeleteVenue } from "hooks/venues";
import { VenuesList, VenuesSearchFilter } from "components/venues";
import { useAppTranslation } from "hooks/useTranslation";

const perPage = 10;

export const Venues = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const page = parseInt(searchParams.get("page") || "1", 10);
  const [name, setName] = useState("");
  const { t } = useAppTranslation();

  const { isLoading, isError, error, venues, count } = useQueryVenues({
    name,
    page,
    perPage,
  });

  const deleteVenue = useDeleteVenue(() => {
    // After successful deletion, the venues list will automatically refresh
    // due to the queryClient.invalidateQueries in the hook
  });

  if (isError) {
    return (
      <div>
        {t("errors.something_went_wrong")}
        {error?.message}
      </div>
    );
  }
  if (isLoading) {
    return null;
  }

  const changePage = (page: number) => {
    setSearchParams({ page: page.toString() });
  };

  const goToVenue = (uid: string) => {
    navigate(`/venues/${uid}`);
  };

  const goToCreateVenue = () => {
    navigate(`/venues/create`);
  };

  const handleVenueDelete = (uid: string) => {
    deleteVenue.mutate({ uid });
  };

  return (
    <Stack>
      <Group justify="space-between">
        <VenuesSearchFilter onUpdateName={setName} />
        <Button onClick={goToCreateVenue}>{t("common.create")}</Button>
      </Group>
      <VenuesList
        venues={venues || []}
        onVenueChosen={goToVenue}
        onVenueDelete={handleVenueDelete}
      />
      <Center mt="xl">
        <Pagination
          mr="xl"
          value={page}
          total={Math.ceil(count! / perPage)}
          onChange={changePage}
        />
      </Center>
    </Stack>
  );
};
